import React from 'react';
import Icon from './Icon';

interface ToastProps {
  type: 'success' | 'error';
  text: string;
  onDismiss: () => void;
}

const Toast: React.FC<ToastProps> = ({ type, text, onDismiss }) => (
  <div className={`message message-${type}`}>
    <span>{type === 'success' ? '✓' : '✕'} {text}</span>
    <button className="message-dismiss" onClick={onDismiss} aria-label="Dismiss">
      <Icon name="close" className="icon icon-sm" />
    </button>
  </div>
);

export default Toast;
